import { Checkbox as ACheckbox, type CheckboxProps } from 'antd';

const Checkbox = ({ onClick, checked = false, id = '' }: CheckboxProps) => {
  return <ACheckbox className="normal-checkbox" id={id} onClick={onClick} checked={checked} />;
};

export default Checkbox;
